export default __webpack_public_path__ + "ba2ba97b77b6b05f1dee56b650dc43e8.jpg";